/**
 * When work is due, in bands a person acts on (C4).
 *
 * The inbox sorted by when somebody last TOUCHED an item, so two
 * undated draft CAPs sat above an assessment cycle due in thirty days
 * -- it answered "what did I touch last?" when the question every
 * morning is "what is due?".
 *
 * Pure, so the boundaries are testable without a clock in a browser.
 */
import type { WorkItem } from "shared/api/types";

export type DueBand = "overdue" | "thisWeek" | "later" | "undated";

export const BAND_ORDER: DueBand[] = ["overdue", "thisWeek", "later", "undated"];

/** Which band an ISO date falls in, relative to `today` (ISO date). */
export function bandFor(due: string | null | undefined, today: string): DueBand {
  if (!due) return "undated";
  const d = due.slice(0, 10);
  if (d < today) return "overdue";
  const week = new Date(`${today}T00:00:00Z`);
  week.setUTCDate(week.getUTCDate() + 7);
  return d <= week.toISOString().slice(0, 10) ? "thisWeek" : "later";
}

/** Group items into bands, preserving the server's order within each. */
export function groupByDue(
  items: WorkItem[],
  today: string,
): Record<DueBand, WorkItem[]> {
  const out: Record<DueBand, WorkItem[]> = {
    overdue: [],
    thisWeek: [],
    later: [],
    undated: [],
  };
  for (const item of items) {
    out[bandFor(item.due_date, today)].push(item);
  }
  return out;
}
